import { Switch, Route } from 'react-router-dom';

import Plan from 'views/Plan';
import Detail from 'views/Detail';

function App() {
  return (
    <div className="app">
      <Switch>
        <Route exact path="/">
          <Plan></Plan>
        </Route>
        <Route path="/detail">
          <Detail></Detail>
        </Route>
        <Route path="*">404</Route>
      </Switch>
    </div>
  );
}

export default App;
